module.exports = __webpack_public_path__ + "img/content_img02.b5509531.jpg";